import { render } from "./image_template.vue?vue&type=template&id=94f28a2e"
import script from "./image_template.vue?vue&type=script&lang=js"
export * from "./image_template.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/image_template.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94f28a2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94f28a2e', __exports__)) {
    api.reload('94f28a2e', __exports__)
  }
  
  module.hot.accept("./image_template.vue?vue&type=template&id=94f28a2e", () => {
    api.rerender('94f28a2e', render)
  })

}


export default __exports__